import { ISourceOptions } from '@tsparticles/engine';
import { LazyParticles } from '../lazy-particles';
import { FC } from 'react';
import { IParticlesProps } from '@tsparticles/react';

const options: ISourceOptions = {
  fullScreen: {
    enable: false,
  },
  particles: {
    color: {
      value: ['#00FFFC', '#FC00FF', '#fffc00', '#FF0000', '#00FF00'],
    },
    move: {
      direction: 'bottom',
      enable: true,
      outModes: {
        default: 'out',
      },
      size: true,
      speed: {
        min: 4,
        max: 6,
      },
    },
    number: {
      value: 500,
      density: {
        enable: true,
      },
    },
    opacity: {
      value: 2,
      animation: {
        enable: false,
        startValue: 'max',
        destroy: 'min',
        speed: 0.3,
        sync: true,
      },
    },
    rotate: {
      value: {
        min: 0,
        max: 360,
      },
      direction: 'random',
      move: true,
      animation: {
        enable: true,
        speed: 60,
      },
    },
    tilt: {
      direction: 'random',
      enable: true,
      move: true,
      value: {
        min: 0,
        max: 360,
      },
      animation: {
        enable: true,
        speed: 60,
      },
    },
    shape: {
      type: ['square'],
      options: {},
    },
    size: {
      value: {
        min: 3,
        max: 6,
      },
    },
    roll: {
      darken: {
        enable: true,
        value: 30,
      },
      enlighten: {
        enable: true,
        value: 30,
      },
      enable: true,
      speed: {
        min: 15,
        max: 25,
      },
    },
    wobble: {
      distance: 30,
      enable: true,
      move: true,
      speed: {
        min: -15,
        max: 15,
      },
    },
  },
};

export const TopDownConfetti: FC<Omit<IParticlesProps, 'options'>> = (
  props
) => {
  return <LazyParticles {...props} options={options} />;
};
